// extracted by mini-css-extract-plugin
export default {"requisites":"Requisites_requisites__PCVJp","item":"Requisites_item__r-Rb9","title":"Requisites_title__ljkV0","description":"Requisites_description__3+N8S"};